import { apiGet, apiPost, apiPut } from '.';
import {
  BareUserNotification,
  UserNotificationStatus,
  UserNotificationTier,
} from '../../../shared/types/userNotification';

export function getNotifications(status?: UserNotificationStatus): Promise<BareUserNotification[]> {
  let queryParams: any = {};

  if (status) queryParams.status = status;

  return apiGet(`/notification`, queryParams);
}

export function getNotificationsByProperty(
  propertyId: string,
  status?: UserNotificationStatus
): Promise<BareUserNotification[]> {
  let queryParams: any = {};

  if (status) queryParams.status = status;

  return apiGet(`/property/${propertyId}/notification`, queryParams);
}

export function changeStatus(notificationId: string, newStatus: UserNotificationStatus) {
  return apiPut(`/notification/${notificationId}/status`, { status: newStatus });
}

export function markAllAsRead(tier: UserNotificationTier) {
  return apiPost(`/notification-read`, { tier });
}
